export default __webpack_public_path__ + "static/media/home4.d2456804.jpg";